const CatalogLandingAppView = () =>
  import(
    /*webpackChunkName: "CatalogLandingAppView"*/ "../../../views/app/CatalogLandingApp.vue"
  );

const catalogLandingMeta = {
  requiresAuth: false,
  requiresEntitlement: false,
  isAmbiguous: true,
};

export const moviesLanding = {
  path: "movies",
  name: "movies-landing",
  alias: "peliculas",
  props: () => ({
    assetType: "movie",
  }),
  component: CatalogLandingAppView,
  meta: catalogLandingMeta,
};

export const seriesLanding = {
  path: "series",
  name: "series-landing",
  props: () => ({
    assetType: "series",
  }),
  component: CatalogLandingAppView,
  meta: catalogLandingMeta,
};
